import React from "react";

export function WorkspacePeek({ workspace, direction, onSelect }) {
  if (!workspace) return <div className="lw-peek lw-peek--empty" aria-hidden="true" />;
  return (
    <button
      type="button"
      className={`lw-peek lw-peek--${direction} lw-accent--${workspace.accent || "cyan"}`}
      onClick={onSelect}
      aria-label={`${direction === "previous" ? "Previous" : "Next"}: ${workspace.title}`}
    >
      <span className="lw-peek__arrow" aria-hidden="true">{direction === "previous" ? "‹" : "›"}</span>
      <span className="lw-kicker">{workspace.eyebrow || (workspace.kind === "add" ? "Custom" : "Workspace")}</span>
      <strong>{workspace.title}</strong>
      <small>{workspace.object?.status || workspace.summary}</small>
    </button>
  );
}
